import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
// Reown Metrics and analytics is switched off
(window as any).ClientAnalytics = {
  init: () => { },
  identify: () => { },
  PlatformName: { web: 'web' }
};

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
